<template>
  <v-container fluid style="padding: 0; height: 100%;">
      <v-card style="height: 100%;"> 
        <v-card-title class="primary white--text">
          <span class="headline">Product Summary</span>
          <v-spacer />
          <v-btn icon dark @click.native="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
      
          <v-stepper v-model="stepValue" vertical  v-if="currentProd != null">
            <v-stepper-step :complete="stepValue > 1" step="1">Step : 1 <h3 class = "error--text text--darken-4">{{duplicateError}}</h3></v-stepper-step>
            
            <v-stepper-content step="1">
              <v-card class="mb-12" style="height:100%">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm4 md4>       
                        <v-combobox
                          v-model="currentProd.name"
                          :items="productListByBrand"
                          :return-object="false"
                          item-text="name"
                          item-value="name"
                          @change="duplicateCheck()"
                          label="Product Name"
                          placeholder="Enter Product name"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs12 sm2 md2>  
                         <v-switch
                            v-model="currentProd.isActive"
                            :label="currentProd.isActive ? 'Active' : 'Inactive'"
                            ></v-switch>     
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                            dense
                            :items="productGroupListByBrand"
                            label="Select Group"
                            item-text="text"
                            item-value="value"
                            v-model="currentProd.productGroup"
                          ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                            dense
                            :items="firmsByBrand"
                            label="Select Firm"
                            item-text="text"
                            item-value="value"
                            v-model="currentProd.firm"
                          ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3 >
                        <v-text-field
                         type="number"
                         v-model="currentProd.weight"
                         label="Product Weight"
                       ></v-text-field>
                     </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          type="text"
                          label="Product Description"
                          v-model="currentProd.description"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                            dense
                            :items="productTypeListByBrand"
                            label="Select Type"
                            item-text="text"
                            item-value="value"
                            v-model="currentProd.productType"
                          ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                            dense
                            :items="productCategoryListByBrand"
                            label="Select Category"
                            item-text="text"
                            item-value="value"
                            v-model="currentProd.productCategory"
                          ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          type="text"
                          label="Product Barcode"
                          v-model="currentProd.barcode"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs12 sm2 md2>
                        <v-btn color="primary" @click="generateBarcode(null)">Generate New Barcode</v-btn>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs12 sm2 md2>
                        <v-btn color="primary" @click="printBarcode()">Print Barcode</v-btn>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs12 sm4 md4  v-if="currentProd.barcode">
                        Barcode Image
                        <br>
                       <svg id="barcode"></svg>
                      </v-flex>
                      <v-flex xs12 sm4 md4 v-if="currentProd.businessType == 'Medical/Pesticides'">
                        <v-autocomplete
                          :items="compositionSuggestions"
                          v-model="currentProd.composition"
                          label="Select or Add Composition"
                          @keyup.native.enter="addComposition"
                          multiple
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-text-field
                          type="number"
                          label="Set Alert Quantity"
                          v-model="currentProd.alertQuantity"
                        ></v-text-field>
                      </v-flex>  
                      <v-flex xs12 sm3 md3>
                        <v-select
                          dense
                          :items="GST_types"
                          label="Select GST type"
                          v-model="currentProd.GST_type"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3 v-if="currentProd.GST_type === 'TAXABLE'" >
                        <v-select
                          type="number"
                          dense
                          :items="[3,5,12,18,28]"
                          v-model="currentProd.taxableGST_rate"
                          :disabled="currentProd.GST_type != 'TAXABLE'"
                          label="Taxable GST rate"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          type="number"
                          v-model="currentProd.HSN_code"
                          label="HSN code"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3 v-if="!currentProd.unitsDeatilsAdded">
                        <v-select
                          dense
                          :items="units"
                          label="Select unit"
                          v-model="currentProd.unit"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3 v-if="!currentProd.unitsDeatilsAdded">
                       <v-select
                         dense
                         :items="units"
                         label="Select Major Unit"
                         v-model="currentProd.majorUnit"
                       ></v-select>
                     </v-flex>
                      <v-flex xs12 sm3 md3 v-if="!currentProd.unitsDeatilsAdded">
                        <v-text-field
                         type="number"
                         v-model="currentProd.majorUnitQuantity"
                         label="Major Unit Quantity"
                       ></v-text-field>
                     </v-flex>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            dense
                            :items="[
                              {
                                text: 'Yes',
                                value: true
                              },
                              {
                                text: 'No',
                                value: false
                              },
                              ]"
                            label="Do you have Multiple units Of Product?"
                            v-model="currentProd.unitsDeatilsAdded"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12 v-if="currentProd.unitsDeatilsAdded">
                      <v-layout wrap>
                        <template v-for="unitDetail in currentProd.unitsDetails">
                           <v-flex :key="unitDetail.order + 'flex1'" xs2>
                           <v-select
                              dense
                              :items="units"
                              :key="unitDetail.order + 'unit'"
                              :label="'Select unit ( ' + unitDetail.order + '.)'"
                              v-model="unitDetail.unit"
                            ></v-select>
                           </v-flex>
                             <v-flex :key="unitDetail.order + 'flex3'" xs2>
                              <v-text-field
                                type="number"
                                :key="unitDetail.order + 'rateP'"
                                v-if="unitDetail.unit"
                                v-model="unitDetail.purchasingPrice"
                                :label="'Purchasing Rate of 1 '+ unitDetail.unit"
                              ></v-text-field>
                            </v-flex>
                             <v-flex :key="unitDetail.order + 'flex6'" xs2>
                              <v-text-field
                                type="number"
                                :key="unitDetail.order + 'rateS'"
                                v-if="unitDetail.unit"
                                v-model="unitDetail.sellingPrice"
                                :label="'Selling Rate of 1 '+ unitDetail.unit"
                              ></v-text-field>
                            </v-flex>
                            <v-flex :key="unitDetail.order + 'flex2'" xs2>
                              <v-text-field
                                type="number"
                                v-if="!unitDetail.isFirst"
                                :key="unitDetail.order + 'quantity'"
                                v-model="unitDetail.quantity"
                                :label="'Quantity'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex :key="unitDetail.order + 'flex4'" xs2>
                              <v-btn
                                v-if="unitDetail.isLast && unitDetail.unit" :key="unitDetail.order + 'add'"
                                  flat
                                  class="primary white--text"
                                  @click="addUnitData(unitDetail)"
                                  >Add next unit 
                                <v-icon>add</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex :key="unitDetail.order + 'flex5'" xs2>
                               <v-btn
                                  v-if="unitDetail.isLast && !unitDetail.isFirst" :key="unitDetail.order + 'close'"
                                  class="primary white--text"
                                  @click="removeUnitData(unitDetail)"
                                  >Remove
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-flex>
                        </template>
                      </v-layout>
                    </v-flex>
                    <!-- </v-layout> -->
                    <v-flex xs12 sm6 md3 v-if="currentProd.businessType == 'Jwellery'">
                      <v-switch
                        v-model="currentProd.isSpecialChargePercentage"
                        :label="`Labour Charge: ${currentProd.isSpecialChargePercentage ? '%' : '₹'}`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="currentProd.isSpecialChargePercentage" >
                      <v-text-field
                        :disabled="!currentProd.isSpecialChargePercentage"
                        type="number"
                        @keyup="calculateSpecialCharge()" 
                        suffix="%"
                        v-model.number="currentProd.specialChargePercentage" 
                        label="Labour Charge in %">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="currentProd.isSpecialChargePercentage">
                      <v-text-field
                        type="number" 
                        suffix="₹"
                        :disabled="currentProd.isSpecialChargePercentage"
                        v-model.number="currentProd.specialCharge"
                        label="Labour Charge in ₹">
                      </v-text-field>
                    </v-flex>
                    </v-layout>
                  </v-container>
                  <v-btn color="primary" @click="stepValue = 2">Next</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepValue > 2" step="2">Step : 2</v-stepper-step>

            <v-stepper-content step="2">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                          ]"
                        label="Do you have Opening Balance Of Product?"
                        v-model="isOpeningBalance"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isOpeningBalance">
                    <v-flex xs12 sm6 md6 v-if="isOpeningBalance">
                        <v-menu
                          :close-on-content-click="false"
                          v-model="datepicker"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="currentProd.openingDate"
                            label="Date"
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="currentProd.openingDate" @input="datepicker = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="currentProd.quantity"
                        :label="'Opening Quantity (in ' + this.currentProd.unitsDeatilsAdded ? this.getLastUnit : this.currentProd.unit+')'"
                      ></v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        type="number"
                        v-model="currentProd.openingBalance"
                        label="Opening Amount"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        :disabled="true"
                        type="number"
                        :value="(Number.parseFloat((currentProd.openingBalance * 100) / (currentProd.taxableGST_rate + 100))).toFixed(2) "
                        label="Basic Value"
                      ></v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        :disabled="true"
                        type="number"
                        :value="(Number.parseFloat ((currentProd.openingBalance || 0) - ((currentProd.openingBalance * 100) / (currentProd.taxableGST_rate + 100)))).toFixed(2) "
                        label="GST Value"
                      ></v-text-field>
                    </v-flex>
                    <template v-for="cat in productRateCategories">
                      <v-flex xs12 sm6 :key="cat['.key'] + 'a'">
                          <v-text-field
                          :disabled="true"
                          :value="cat.name"
                          label="Category"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 :key="cat['.key'] + 'b'">
                         <v-text-field
                          type="number"
                          v-model="currentProd.sellingPriceByCategories[cat['.key']]"
                          label="Selling Price"
                        ></v-text-field>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn color="primary" @click="stepValue = 3">Next</v-btn>
                  <v-btn text @click="stepValue = 1">Back</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepValue > 3" step="3">Step : 3</v-stepper-step>

            <v-stepper-content step="3">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                        ]"
                        label="Do you want to add Standard Price of the Product?"
                        v-model="isStanderedPrice"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="isStanderedPrice">
                      <v-select
                        dense
                        :disabled="true"
                        :items="units"
                        label="Selected unit"
                        :value="this.currentProd.unitsDeatilsAdded ? this.getLastUnit : this.currentProd.unit"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="isStanderedPrice">
                      <v-select
                        dense
                        :items="[3,5,12,18,28]"
                        v-model="currentProd.taxableGST_rate"
                        :disabled="true"
                        label="Taxable GST rate"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm3 md3 v-if="isStanderedPrice && currentProd.taxableGST_rate">
                      <v-switch
                            v-model="addIncPrice"
                            :label="addIncPrice ? 'Mention Price Including GST' : 'Mention Price Excluding GST'"
                            ></v-switch>    
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isStanderedPrice"> 
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        :disabled="addIncPrice"
                        v-model="currentProd.purchasingPrice"
                        label="Purchasing Price [Excluding GST]"
                      ></v-text-field>
                    </v-flex>
                     <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                         :disabled="!addIncPrice"
                        v-model="purchasingPriceInc"
                        label="Purchasing Price [Including GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                         :disabled="addIncPrice"
                        v-model="currentProd.sellingPrice"
                        label="Selling Price [Excluding GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                         :disabled="!addIncPrice"
                        v-model="sellingPriceInc"
                        label="Selling Price [Including GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        type="number"
                        v-model="currentProd.MRPRate"
                        label="MRP [Including GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <!-- Labour Charge Addition -->
                    <!-- <v-flex xs12 sm2 md2>
                      <v-switch
                        v-model="currentProd.isSpecialChargePercentage"
                        :label="`Labour Charge: ${currentProd.isSpecialChargePercentage ? '%' : '₹'}`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        :disabled="!currentProd.isSpecialChargePercentage"
                        type="number"
                        @keyup="calculateSpecialCharge()" 
                        suffix="%"
                        v-model.number="currentProd.specialChargePercentage" 
                        label="Labour Charge in %">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        type="number" 
                        suffix="₹"
                        :disabled="currentProd.isSpecialChargePercentage"
                        v-model.number="currentProd.specialCharge"
                        label="Labour Charge in ₹">
                      </v-text-field>
                    </v-flex> -->
                    <!-- End of Labour Charge -->                   
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn text @click="stepValue = 2">Back</v-btn>
                  <v-btn color="primary" @click="saveProduct(false)" v-if="!currentProd['.key']">Save</v-btn>
                  <v-btn color="primary" @click="saveProduct(true)" v-if="!currentProd['.key']">Save & add</v-btn>
                  <v-btn
                    color="primary"
                    @click="updateProduct"
                    v-if="!!currentProd['.key']"
                  >Update</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { barcodePrintPDF } from "../../utils/barcodePrint";

export default {
    props: {
    currentProduct : Object,
    stepperValue : Number
  },
  data() {
    return {
      defaultFirm : null,
      compositionSuggestions : [],
      suggestionAdded : false,
      stepValue : 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      sellingPriceInc : 0,
      purchasingPriceInc : 0,
      addIncPrice : false,
      datepicker : false,
      duplicateError : null,
      productList: [],
      currentProd : null,
      GST_types: [
         {
           text: "Exempt",
           value: "EXEMPT"
         },
         {
           text: "Nil Rated",
           value: "NILL"
         },
         {
           text: "Taxable",
           value: "TAXABLE"
         },
         {
           text: "Non-GST",
           value: "OTHER"
         }
       ]
    };
  },
  created() {
    this.stepValue = this.stepperValue;
    this.currentProd = this.currentProduct;
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('productCategories', this.$root.$firebaseRefs.productCategory.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('productTypes', this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("productRateCategories", this.$root.$firebaseRefs.productRateCategory.orderByChild('brand').equalTo(this.selectedBrand))
    if(this.$route.params.isNew) {
      this.addProduct();
    }
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    firmsByBrand() {
      let firmsB =  this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm && !this.currentProd.firm){
              this.currentProd.firm = item[".key"];
              this.currentProd.businessType = item["businessType"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
        return firmsB;
    },
    productListByBrand() {
      let prod = this.productList.filter(
        item => {
          return (item["brand"] === this.selectedBrand && 
          // (item.openingDate ? (item.openingDate >= this.finYear.start) 
          // && (item.openingDate <= this.finYear.end) : true) 
          (!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true))
        }
      );
      if(!this.suggestionAdded) {
        this.compositionSuggestions =[];
      }
      prod.map((p)=>{
        if(!this.suggestionAdded) {
          if(p.composition && this.compositionSuggestions.indexOf(p.composition)==-1) {
            this.compositionSuggestions.push(p.composition)
          }
        }
        if(p.unitsDeatilsAdded) {
          p['openingQuantityTitle']= this.getFilteredQuantity(p,p['openingQuantity'])
          p['purchaseQuantityTitle']= this.getFilteredQuantity(p,p['purchaseQuantity'])
          p['saleQuantityTitle']= this.getFilteredQuantity(p,p['saleQuantity'])
          p['closingQuantityTitle']= this.getFilteredQuantity(p,((Number.parseFloat(p['openingQuantity']) + Number.parseFloat(p['purchaseQuantity'])) -  Number.parseFloat(p['saleQuantity'])))
        }
      })
      return prod;
    },

    productGroupListByBrand() {
      return this.productGroups
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    productCategoryListByBrand() {
      return this.productCategories
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    productTypeListByBrand() {
      return this.productTypes
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    getLastUnit() {
      let lastUnit = _.maxBy(this.currentProd.unitsDetails, 'order');
      return lastUnit ? lastUnit.unit : '';
    },
    getLastRate() {
      let lastUnit = _.maxBy(this.currentProd.unitsDetails, 'order');
      return lastUnit ? lastUnit.rate : '';
    }
  },
  methods: {
    generateBarcode(barcode){
      if(barcode == null) {
        this.currentProd.barcode = new Date().getTime() + "";
      }
    },
    async printBarcode(){
        await barcodePrintPDF({
      })
    },
    close(){
        this.$emit("close");
    },
    addComposition(e){
      this.suggestionAdded = true;
      this.compositionSuggestions.push(e.target.value)
    },
     getBusinessType(){
      let firm = this.firms.filter((item) => item[".key"] === this.currentProd['firm'])[0];
      this.currentProd.businessType = firm['businessType'];
    },
     getFilteredQuantity(product,qty){
      let quantity = qty;
      let string = "";
          product.unitsDetails.sort(function(a,b){
            return (new Date(b.order) - new Date(a.order));
          });
          for (var i = 0; i < product.unitsDetails.length; i++) {
             if(quantity > Number.parseFloat(product.unitsDetails[i].quantity) && i+1 <product.unitsDetails.length) {
              let temp  = Number.parseFloat(quantity)/Number.parseFloat(product.unitsDetails[i].quantity);
                string = (("("+((temp).toString().split(".")[1] ? (temp).toString().split(".")[1] : 0) + " "+product.unitsDetails[i].unit+") ")+ string);
                quantity = Number.parseInt((temp).toString().split(".")[0])
              } else {
                string = (("("+quantity + " "+product.unitsDetails[i].unit+") ")+ string);
                break;
              }
          }
          // console.log(string)
        return string;
    },
    addUnitData(data){
      delete data['isLast']
      this.currentProd.unitsDetails.push({
        unit:'',
        order : data.order+1,
        quantity : 0,
        isLast : true,
      })
    },
    removeUnitData(){
      this.currentProd.unitsDetails.pop();
      this.currentProd.unitsDetails[this.currentProd.unitsDetails.length-1]['isLast'] = true;
    },
    duplicateCheck(){
       let duplicateCheck = this.productList.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentProd.name
      );
      if(duplicateCheck.length) {
          this.duplicateError = 'Product with name ' + this.currentProd.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      }
    },
    saveProduct(saveAndAdd) {
      if(this.currentProd.unitsDeatilsAdded) {
        this.currentProd.unit = this.getLastUnit;
      } else {
        delete this.currentProd['unitsDetails']
      }
      let duplicateCheck = this.productList.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentProd.name
      );
      if(duplicateCheck.length) {
          this.duplicateError = 'Product with name ' + this.currentProd.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      } else {
        this.currentProd["brand"] = this.selectedBrand;
        this.currentProd["HSN_code"] = Number.parseFloat(
          this.currentProd.HSN_code
        );
        this.currentProd["taxableGST_rate"] = Number.parseFloat(
          this.currentProd.taxableGST_rate
        );
        this.currentProd.purchaseQuantity = 0;
        this.currentProd.saleQuantity = 0;
        this.currentProd.openingQuantity = this.currentProd.quantity;
        this.currentProd.openingDate = new Date(this.currentProd.openingDate).getTime()
        delete this.currentProd['openingQuantityTitle'];
        delete this.currentProd['purchaseQuantityTitle'];
        delete this.currentProd['saleQuantityTitle'];
        delete this.currentProd['closingQuantityTitle'];
        this.$root.$firebaseRefs.products.push(this.currentProd);
        this.$emit("saveProduct",saveAndAdd);
      }
    },
    updateProduct() {
      if(this.currentProd.unitsDeatilsAdded) {
        this.currentProd.unit = this.getLastUnit;
      } else {
        delete this.currentProd['unitsDetails']
      }
      let key = this.currentProd[".key"];
      delete this.currentProd[".key"];
      this.currentProd.openingDate = new Date(this.currentProd.openingDate).getTime()
      this.currentProd.openingQuantity = this.currentProd.quantity;
      this.currentProd.quantity = ((Number.parseFloat(this.currentProd.openingQuantity) + Number.parseFloat(this.currentProd.purchaseQuantity)) - Number.parseFloat(this.currentProd.saleQuantity))
      delete this.currentProd['openingQuantityTitle'];
      delete this.currentProd['purchaseQuantityTitle'];
      delete this.currentProd['saleQuantityTitle'];
      delete this.currentProd['closingQuantityTitle'];
      this.$root.$firebaseRefs.products.child(key).set(this.currentProd);
      this.currentProd = {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode:"",
        quantity: 0,
        unit: "",
        openingDate : new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice : 0,
        gstValue : 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
      };
      this.$emit("updateProduct");
    },
    calculateOpeningBalance() {
      if(this.currentProd.basicPrice !=0 && this.currentProd.gstValue!=0) {
        this.currentProd.openingBalance = Number.parseFloat(this.currentProd.basicPrice) + Number.parseFloat(this.currentProd.gstValue);
      }
    }
  },
  watch: {
     "currentProd.purchasingPrice": {
      handler(newVal, oldVal) {
        if(!this.addIncPrice) {
          this.purchasingPriceInc = (this.currentProd.taxableGST_rate ? (Number.parseFloat((this.currentProd.purchasingPrice * this.currentProd.taxableGST_rate)/100) + Number.parseFloat(this.currentProd.purchasingPrice)).toFixed(2) : this.currentProd.purchasingPrice);
        }
      },
      deep: true
    },
     "currentProd.sellingPrice": {
      handler(newVal, oldVal) {
        if(!this.addIncPrice) {
          this.sellingPriceInc = (this.currentProd.taxableGST_rate ? (Number.parseFloat((this.currentProd.sellingPrice * this.currentProd.taxableGST_rate)/100) + Number.parseFloat(this.currentProd.sellingPrice)).toFixed(2) : this.currentProd.sellingPrice)
        }
      },
      deep: true
    },
    "sellingPriceInc": {
      handler(newVal, oldVal) {
        if(this.currentProduct.taxableGST_rate && this.addIncPrice) {
          let amount = ((this.sellingPriceInc * this.currentProduct.taxableGST_rate) / 100);
          this.currentProduct.sellingPrice = (this.sellingPriceInc - amount);
        }
      },
      deep: true
    },
     "purchasingPriceInc": {
      handler(newVal, oldVal) {
        if(this.currentProduct.taxableGST_rate && this.addIncPrice) {
          let amount = ((this.purchasingPriceInc * this.currentProduct.taxableGST_rate) / 100);
          this.currentProduct.purchasingPrice = (this.purchasingPriceInc - amount);
        }
      },
      deep: true
    },
    "currentProd.GST_type": {
      handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProd.taxableGST_rate = 0;
        }
      },
      deep: true
    },
    "currentProd.barcode": {
      handler(newVal, oldVal) {
        if(this.currentProd.barcode) {
          JsBarcode("#barcode", this.currentProd.barcode);
        }
      },
      deep: true
    },
    stepperValue(val) {
        console.log("sdsd")
        this.stepValue = val;
    },
    "currentProduct" : {
      handler(newVal, oldVal) {
       this.currentProd = newVal;
      },
      deep: true
    },
     "currentProd.basicPrice": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },
      deep: true
    },
    "currentProd.firm": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getBusinessType();
        }
      },
      deep: true
    },
    "currentProd.gstValue": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },
      deep: true
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Products/addProduct.vue